import { useSearchParams } from 'react-router';

/**
 * Reads the `backTo` return-URL convention shared across the quiz flow.
 * `override` wins over the `?backTo=` search param so a flow that doesn't carry
 * it in the URL (e.g. a dialog opened from the assignment flow) can still set it.
 */
export function useBackTo(override?: string | null) {
  const [searchParams] = useSearchParams();
  const backTo = override ?? searchParams.get('backTo');
  return {
    backTo,
    /** `?backTo=...` suffix to propagate the return URL to the next page, or '' when absent. */
    search: backTo ? `?backTo=${encodeURIComponent(backTo)}` : '',
  };
}
